import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useStyles from "./styles";
import { Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import VendorDescription from "~/components/vendorPage/vendorDescription/VendorDescription";

export const ModalBottom = ({
	children,
	style = {},
	childrenStyle = {},
	title,
	buttonCustom,
	activeButton = false,
	user,
	showFullAddress,
	containerButtonStyle = {},
	showVendorDescription = false,
	setShowVendorDescription,
	animate = true,
	showBackButton = false,
	onBackClick, 
	animationType = "slideUp"
}) => {
	const [height, setHeight] = useState("100vh");
	const [animationKey, setAnimationKey] = useState(0);
	const classes = useStyles({ height, activeButton, animate, animationType });
	const { business } = useSelector((store) => store.business);

	/**
	 * Calcula dinamicamente a altura disponível para um componente da interface,
	 * considerando:
	 * - Se o usuário é anônimo ou autenticado (impacta no offset base e altura de botões);
	 * - Se há um botão ativo (altera a altura ocupada por ele);
	 * - A altura total da janela (window.innerHeight).
	 *
	 * A lógica garante que a interface permaneça visualmente adequada em diferentes dispositivos.
	 */
	useEffect(() => {
		const updateHeight = () => {
			const baseOffset = !user?.isAnonymous ? 390 : 330;
			const buttonHeight = activeButton ? (!user?.isAnonymous ? 70 : 118) : !user?.isAnonymous ? 0 : 50;

			const textHeight = showFullAddress > 0 ? showFullAddress - 50 : 0;

			const available = window.innerHeight - baseOffset - buttonHeight - textHeight;
			setHeight(`${available}px`);
		};

		updateHeight();
		window.addEventListener("resize", updateHeight);

		return () => window.removeEventListener("resize", updateHeight);
	}, [activeButton, showFullAddress, user]);

	useEffect(() => {
		if (animate) {
			setAnimationKey(prev => prev + 1);
		}
	}, [animate]);

	return (
		<>
			<div 
				key={animationKey}
				className={`${classes.container} ${animationType === "slideRight" ? classes.containerSlideRight : ""}`} 
				style={style}
			>
				{showVendorDescription && (
							<div style={{ cursor: "pointer", paddingBottom: 15, display: "flex", justifyContent: "end", alignItems: "center" }} onClick={() => setShowVendorDescription(!showVendorDescription)}>
								<Close />
							</div>
						)}
				
				{/* Header com título e botão de voltar */}
				{(title && !showVendorDescription) && (
					<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
						<Typography className={classes.title} style={{ margin: 0, flex: 1 }}>
							{title}
						</Typography>
						{showBackButton && onBackClick && (
							<div
								style={{
									cursor: "pointer",
									padding: "8px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									borderRadius: "50%",
									backgroundColor: "rgba(0,0,0,0.05)",
									transition: "background-color 0.2s ease",
								}}
								onClick={onBackClick}
								onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(0,0,0,0.1)")}
								onMouseLeave={(e) => (e.target.style.backgroundColor = "rgba(0,0,0,0.05)")}>
								<Close style={{ fontSize: 20, color: "#666" }} />
							</div>
						)}
					</div>
				)}

				{(!title && showBackButton && onBackClick) && (
					<div
						style={{
							cursor: "pointer",
							padding: "8px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							borderRadius: "50%",
							backgroundColor: "rgba(0,0,0,0.05)",
							transition: "background-color 0.2s ease",
							width: "40px",
							height: "40px",
							position: "absolute",
							zIndex: 1000,
							top: 18,
							right: 18,
						}}
						onClick={onBackClick}
						onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(0,0,0,0.1)")}
						onMouseLeave={(e) => (e.target.style.backgroundColor = "rgba(0,0,0,0.05)")}>
						<Close style={{ fontSize: 20, color: "#666" }} />
					</div>
				)}

				{showVendorDescription ? (
					<div className={classes.containerChildren}>
						<VendorDescription business={business} />
					</div>
				) : (
					<div className={classes.containerChildren} style={childrenStyle}>
						{children}
					</div>
				)}

				{activeButton && (
					<div className={classes.fixedButton} style={containerButtonStyle}>
						{buttonCustom()}
					</div>
				)}
			</div>
		</>
	);
};
